export default "Note explicative pour la convocation AG — Copropriétés | Solution Éco France";
